import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home-page',
      component: () => import(/* webpackChunkName: "home" */ '@Page/Home'),
      meta: { pageTitle: 'Bienvenue' }
    },
    {
      path: '/meter-reading',
      component: () => import(/* webpackChunkName: "meter-reading" */ '@Page/MeterReading'),
      meta: { pageTitle: 'Transférer mon index' },
      children: [
        {
          path: 'step1',
          name: 'meterReading-step1',
          component: () => import(/* webpackChunkName: "meter-reading" */ '@Page/MeterReading/Step1')
        },
        {
          path: 'step2',
          name: 'meterReading-step2',
          component: () => import(/* webpackChunkName: "meter-reading" */ '@Page/MeterReading/Step2')
        },
        {
          path: 'step3',
          name: 'meterReading-step3',
          component: () => import(/* webpackChunkName: "meter-reading" */ '@Page/MeterReading/Step3')
        },
        {
          path: 'step4',
          name: 'meterReading-step4',
          component: () => import(/* webpackChunkName: "meter-reading" */ '@Page/MeterReading/Step4')
        },
        {
          path: 'confirmation',
          name: 'meterReading-confirmation',
          component: () => import(/* webpackChunkName: "meter-reading" */ '@Page/MeterReading/Confirmation')
        }
      ]
    },
    {
      path: '/appointment',
      component: () => import(/* webpackChunkName: "appointment" */ '@Page/Appointment'),
      meta: { pageTitle: 'Demande de lecture de compteur' },
      children: [
        {
          path: 'step1',
          name: 'appointment-step1',
          component: () => import(/* webpackChunkName: "appointment" */ '@Page/Appointment/Step1')
        },
        {
          path: 'step2',
          name: 'appointment-step2',
          component: () => import(/* webpackChunkName: "appointment" */ '@Page/Appointment/Step2')
        },
        {
          path: 'step3',
          name: 'appointment-step3',
          component: () => import(/* webpackChunkName: "appointment" */ '@Page/Appointment/Step3')
        },
        {
          path: 'confirmation',
          name: 'appointment-confirmation',
          component: () => import(/* webpackChunkName: "appointment" */ '@Page/Appointment/Confirmation')
        }
      ]
    },
    {
      path: '/consumption',
      component: () => import(/* webpackChunkName: "consumption" */ '@Page/Consumption'),
      meta: { pageTitle: 'Consulter mon historique de consommation' },
      children: [
        {
          path: 'step1',
          name: 'consumption-step1',
          component: () => import(/* webpackChunkName: "consumption" */ '@Page/Consumption/Step1')
        },
        {
          path: 'step2',
          name: 'consumption-step2',
          component: () => import(/* webpackChunkName: "consumption" */ '@Page/Consumption/Step2')
        },
        {
          path: 'confirmation',
          name: 'consumption-confirmation',
          component: () => import(/* webpackChunkName: "consumption" */ '@Page/Consumption/Confirmation')
        }
      ]
    },
    {
      path: '/unsubscribe',
      component: () => import(/* webpackChunkName: "unsubscribe" */ '@Page/Unsubscribe'),
      meta: { pageTitle: 'Désinscription du service e-mailing' },
      children: [
        {
          path: 'step1',
          name: 'unsubscribe-step1',
          component: () => import(/* webpackChunkName: "unsubscribe" */ '@Page/Unsubscribe/Step1')
        },
        {
          path: 'step2',
          name: 'unsubscribe-step2',
          component: () => import(/* webpackChunkName: "unsubscribe" */ '@Page/Unsubscribe/Step2')
        },
        {
          path: 'confirmation',
          name: 'unsubscribe-confirmation',
          component: () => import(/* webpackChunkName: "unsubscribe" */ '@Page/Unsubscribe/Confirmation')
        }
      ]
    },
    {
      path: '/month-of-statement',
      component: () => import(/* webpackChunkName: "month-of-statement" */ '@Page/MonthOfStatement'),
      meta: { pageTitle: 'Mois de relève' },
      children: [
        {
          path: 'step1',
          name: 'monthOfStatement-step1',
          component: () => import(/* webpackChunkName: "month-of-statement" */ '@Page/MonthOfStatement/Step1')
        },
        {
          path: 'step2',
          name: 'monthOfStatement-step2',
          component: () => import(/* webpackChunkName: "month-of-statement" */ '@Page/MonthOfStatement/Step2')
        },
        {
          path: 'confirmation',
          name: 'monthOfStatement-confirmation',
          component: () => import(/* webpackChunkName: "month-of-statement" */ '@Page/MonthOfStatement/Confirmation')
        }
      ]
    },
    {
      path: '/maintenance',
      name: 'maintenance-page',
      component: () => import(/* webpackChunkName: "home" */ '@Page/Maintenance'),
      meta: { pageTitle: ';-)' }
    },
    {
      path: '/cookies-declaration',
      name: 'cookies-declaration-page',
      component: () => import(/* webpackChunkName: "home" */ '@Page/CookiesDeclaration')
    },
    { path: '*', component: () => import(/* webpackChunkName: "home" */ '@Page/NotFound') }
  ],
  scrollBehavior: function(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
